import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ArticoliDisponibili, DettaglioLinee, DettaglioLineeTemporaneo, ModelInvoice } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { ArticoliDisponibiliComponent } from '../dialog/articoli-disponibili/articoli-disponibili.component';
import { InfoDettaglioLineeComponent } from '../dialog/info-dettaglio-linee/info-dettaglio-linee.component';
import { Articolo, GenericResponse } from 'src/app/entities/various';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { UserData, UserInfo } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';
import { ConfirmModalComponent } from 'src/app/components/utils/confirm-modal/confirm-modal.component';


@Component({
  selector: 'app-dati-beni-servizi',
  templateUrl: './dati-beni-servizi.component.html',
  styleUrls: ['./dati-beni-servizi.component.css']
})
export class DatiBeniServiziComponent implements OnInit, OnChanges {

  @Input() model: ModelInvoice | undefined;
  @Input() userInfo!: UserData | undefined;
  @Input() aggiornaFakeLineeEvent: any;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  @Output() refreshRiepilogo = new EventEmitter<any>();

  //serve per aggiornale le linee "Fake" utili alla validazione
  @Output() aggiornaFakeLinee = new EventEmitter<any>();

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1,
        name: "invoices.edit.serviceData.other.tabs.tab1"
      },
      {
        id: 2,
        name: "invoices.edit.serviceData.other.tabs.tab2"
      }
    ]
  }

  note: number[] = [];

  configProps: ConfigProps | undefined;

  fakeLinee: DettaglioLineeTemporaneo[] = [];

  constructor(private configService: ConfigServiceService, private confService: ConfigurationService,
    private modalService: NgbModal, private toastService: ToastService,
    private translate: TranslateService, private userService: UserService) { }

  async ngOnInit() {
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    this.configProps!.list.listDivisa.forEach(e => {
      e.label = e.val + " - " + e.label;
    });
    this.configProps!.list.listCausalePagamento.forEach(o => {
      if (o.text!.length > 150) {
        o.text = o.text?.substr(0, 150) + "...";
      }
    });
    if (this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length == 0)
      this.adddDettaglioLinee()
    else {
      this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.forEach((riga, index) => {
        let obj: DettaglioLineeTemporaneo = new UTILS().deepCopy(riga);
        this.fakeLinee[index] = obj;
        this.fakeLinee[index].validato = true;
        //controllo se è una nota...
        if (this.fakeLinee[index].PrezzoTotale == 0 && this.fakeLinee[index].PrezzoUnitario == '0' && this.fakeLinee[index].Quantita == "0.00") {
          this.fakeLinee[index].isNota = true;
        }
        this.getTotImporto(this.fakeLinee[index]);
      });
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model) {
      this.model = changes.model.currentValue;
    }

    if (this.model && this.configProps) {
      this.fakeLinee = [];

      const linee = this.model?.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee || [];

      if (linee.length == 0) {
        this.adddDettaglioLinee();
        return;
      }

      linee.forEach((riga, index) => {
        let obj: DettaglioLineeTemporaneo = new UTILS().deepCopy(riga);

        this.fakeLinee[index] = obj;
        this.fakeLinee[index].validato = true;

        if (
          this.fakeLinee[index].PrezzoTotale == 0 &&
          this.fakeLinee[index].PrezzoUnitario == '0' &&
          this.fakeLinee[index].Quantita == '0.00'
        ) {
          this.fakeLinee[index].isNota = true;
        }

        this.getTotImporto(this.fakeLinee[index]);
      });
    }

    if (changes.aggiornaFakeLineeEvent) {
      let linee = this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      if (this.fakeLinee.length != 0)
        for (var i = 0; i < linee.length; i++) {
          this.fakeLinee[i].AppCassa = linee[i].AppCassa;
          this.fakeLinee[i].Ritenuta = linee[i].Ritenuta;
        }
    }
  }

  public adddDettaglioLinee() {
    if (this.fakeLinee?.filter(dR => dR.validato == false).length > 0) {
      this.toastService.openToastWithConfig(true, 5000, "Salvare prima le altre linee", "warning");
      return;
    }

    let ritenuta = '';
    let cassa = '';
    if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length > 0)
      ritenuta = 'SI';
    if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length > 0)
      cassa = 'SI';

    this.fakeLinee.push({
      AliquotaIVA: "",
      AltriDatiGestionali: [],
      CodiceArticolo: [],
      DataFinePeriodo: "",
      DataInizioPeriodo: "",
      Descrizione: "",
      Natura: "",
      NumeroLinea: this.fakeLinee.length + 1,
      PrezzoTotale: 0,
      PrezzoUnitario: "",
      Quantita: "1.00",
      RiferimentoAmministrazione: "",
      Ritenuta: ritenuta,
      ScontoMaggiorazione: [],
      UnitaMisura: "",
      AppCassa: cassa,
      validato: false
    });

  }


  public abilitaModificaLinea(index: number) {
    //se esiste una altra riga in modifica non permetto la modifica
    if (this.fakeLinee?.filter(dR => dR.validato == false).length == 0)
      this.fakeLinee[index].validato = false;
    else {
      this.toastService.openToastWithConfig(true, 5000, "Salvare prima le altre linee", "warning");
    }
  }

  public async salvaLinea(index: number) {
    // Convalido la linea
    // Se è correttamente convalidata la inserisco nel dettaglio articoli altrimenti mostro avvisi.
    if (this.controlloIntegritaRiga(index)) {


      if (this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.filter(dR => dR.NumeroLinea == this.fakeLinee[index].NumeroLinea).length == 0) {
        /*if(this.fakeLinee[index].AliquotaIVA=='0.00')
                this.fakeLinee[index].Ritenuta='';*/
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.push({
          AliquotaIVA: this.fakeLinee[index].AliquotaIVA,
          AltriDatiGestionali: this.fakeLinee[index].AltriDatiGestionali,
          CodiceArticolo: this.fakeLinee[index].CodiceArticolo,
          DataFinePeriodo: this.fakeLinee[index].DataFinePeriodo,
          DataInizioPeriodo: this.fakeLinee[index].DataInizioPeriodo,
          Descrizione: this.fakeLinee[index].Descrizione,
          Natura: this.fakeLinee[index].Natura,
          NumeroLinea: this.fakeLinee[index].NumeroLinea,
          PrezzoTotale: this.fakeLinee[index].PrezzoTotale,
          PrezzoUnitario: this.fakeLinee[index].PrezzoUnitario,
          Quantita: this.fakeLinee[index].Quantita,
          RiferimentoAmministrazione: this.fakeLinee[index].RiferimentoAmministrazione,
          Ritenuta: this.fakeLinee[index].Ritenuta,
          ScontoMaggiorazione: this.fakeLinee[index].ScontoMaggiorazione,
          UnitaMisura: this.fakeLinee[index].UnitaMisura,
          AppCassa: this.fakeLinee[index].AppCassa,
        });
      } else {
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].AliquotaIVA = this.fakeLinee[index].AliquotaIVA;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].AltriDatiGestionali = this.fakeLinee[index].AltriDatiGestionali;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].CodiceArticolo = this.fakeLinee[index].CodiceArticolo;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].DataFinePeriodo = this.fakeLinee[index].DataFinePeriodo;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].DataInizioPeriodo = this.fakeLinee[index].DataInizioPeriodo;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].Descrizione = this.fakeLinee[index].Descrizione;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].Natura = this.fakeLinee[index].Natura;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].NumeroLinea = this.fakeLinee[index].NumeroLinea;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].PrezzoTotale = this.fakeLinee[index].PrezzoTotale;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].PrezzoUnitario = this.fakeLinee[index].PrezzoUnitario;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].Quantita = this.fakeLinee[index].Quantita;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].RiferimentoAmministrazione = this.fakeLinee[index].RiferimentoAmministrazione;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].Ritenuta = this.fakeLinee[index].Ritenuta;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].ScontoMaggiorazione = this.fakeLinee[index].ScontoMaggiorazione;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].UnitaMisura = this.fakeLinee[index].UnitaMisura;
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].AppCassa = this.fakeLinee[index].AppCassa;
      }

      this.ricalcolaCassePrevidenziali();

      this.fakeLinee[index].validato = true;
      this.refreshRiepilogo.emit();
    }
  }



  public controlloIntegritaRiga(index: number) {
    let riga = this.fakeLinee[index];
    if (riga.Descrizione == "") {
      this.toastService.openToastWithConfig(true, 5000, "Inserisci la descrizione", "warning");
      return false;
    }
    if (riga.Quantita == "" || !this.isNumber(riga.Quantita)) {
      this.toastService.openToastWithConfig(true, 5000, "Inserisci la quantità", "warning");
      return false;
    }
    if (riga.PrezzoUnitario == "" || !this.isNumber(riga.PrezzoUnitario)) {
      this.toastService.openToastWithConfig(true, 5000, "Inserisci il prezzo unitario", "warning");
      return false;
    }
    if (riga.AliquotaIVA == "" || (parseFloat("" + riga.AliquotaIVA) == 0 && riga.Natura == "")) {
      this.toastService.openToastWithConfig(true, 5000, "Correggi aliquota iva e Natura", "warning");
      return false;
    }
    //se sono arrivato qui dovrebbe essere tutto ok...
    //calcolo l'importo
    this.getTotImporto(riga);
    this.controlloFlagCassa(index);
    return true;
  }

  public isNumber(n: string) {
    return !isNaN(parseFloat(n));
  }

  public controlloFlagCassa(index: number) {
    if (this.fakeLinee[index].Natura == 'N1') {
      this.fakeLinee[index].AppCassa = '';
    }
  }

  public controlloFlagRitenuta(index: number) {
    /*if(this.fakeLinee[index].AliquotaIVA=='0.00')
                this.fakeLinee[index].Ritenuta='';*/
  }

  public addNota() {
    //aggiungo una linea solo se esiste almeno una riga con aliquota iva valida cioè esiste un riepilogo valido
    if ((this.fakeLinee.length > 0)) {

      //setto aliquota iva e natura dell'ultima riga del riepilogo
      if (this.fakeLinee?.filter(dR => dR.validato == false).length > 0) {
        this.toastService.openToastWithConfig(true, 5000, "Salvare prima le altre linee", "warning");
        return;
      }

      let riepilogo = this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0];

      this.fakeLinee.push({
        AliquotaIVA: riepilogo.AliquotaIVA,
        AltriDatiGestionali: [],
        CodiceArticolo: [],
        DataFinePeriodo: "",
        DataInizioPeriodo: "",
        Descrizione: "",
        Natura: riepilogo.Natura,
        NumeroLinea: this.fakeLinee.length + 1,
        PrezzoTotale: 0,
        PrezzoUnitario: "0.00",
        Quantita: "0.00",
        RiferimentoAmministrazione: "",
        Ritenuta: "",
        ScontoMaggiorazione: [],
        UnitaMisura: "",
        AppCassa: "",
        validato: false,
        isNota: true
      });
    }
    else {
      this.toastService.openToastWithConfig(true, 5000, "Inserisci almeno un articolo", "warning");
    }
  }


  public deleteDettaglioLinee(index: number) {
    //controllo se esiste una modifica in corso...
    if ((this.fakeLinee[index].validato == true) && (this.fakeLinee!.filter(dR => dR.validato == false).length > 0)) {
      this.toastService.openToastWithConfig(true, 5000, "Salvare prima le altre linee", "warning");
      return;
    }

    //controllo se esistono solo 2 linee di cui una è una nota...
    let note = this.fakeLinee.filter(dR => dR?.isNota == true).length;
    if (note > 0) {
      //devo controllare se eliminando index, non rimangono solo note.. Una linea di riepilogo deve esistere.
      if (!this.fakeLinee[index]?.isNota == true) {
        let note = 0;
        this.fakeLinee.forEach((riga, i) => {
          if (riga?.isNota == true)
            note++;
        });
        if ((this.fakeLinee.length - note) == 1) {
          this.toastService.openToastWithConfig(true, 5000, "Non è possibile eliminare questa riga. Una nota deve coesistere con almeno un bene o servizio.Per eliminare questa riga rimuovere la nota o aggiungere un bene/servizio.", "error");
          return;
        }
      }

    }


    //controllo se esiste nel modello una linea con lo stesso numero linea
    let NumeroLinea = this.fakeLinee[index].NumeroLinea;
    if (this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.filter(dR => dR.NumeroLinea == NumeroLinea).length > 0) {
      let true_index = 0;
      this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.forEach((riga, i) => {
        if (riga.NumeroLinea == NumeroLinea)
          true_index = i;
      });
      this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.splice(true_index, 1);
    }

    //controllo se esistevano casse applicate..
    this.fakeLinee.splice(index, 1);
    this.fakeLinee.forEach((i, index) => i.NumeroLinea = index + 1);
    this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.forEach((i, index) => i.NumeroLinea = index + 1);
    this.refreshRiepilogo.emit();
    this.ricalcolaCassePrevidenziali();
  }

  public async articoliDisponibili(line: DettaglioLineeTemporaneo) {
    let modalRef = this.modalService.open(ArticoliDisponibiliComponent, { size: 'lg' });
    let response: ArticoliDisponibili | undefined = await modalRef.result.then(result => { return result; }).catch(err => { return null });
    if (response) {
      line.AliquotaIVA = new UTILS().parseFloat("" + response.aliquotaiva);
      if (line.AliquotaIVA == '0.00')
        line.Ritenuta = '';
      line.Descrizione = response.descrizione;
      line.Natura = response.natura;
      line.PrezzoUnitario = new UTILS().parseFloat("" + response.prezzounitario);
      line.UnitaMisura = response.unitadimisura;
      line.PrezzoTotale = response.prezzounitario;
    }
  }

  public async modificaDettaglioLinee(dL: DettaglioLineeTemporaneo) {
    let modalRef = this.modalService.open(InfoDettaglioLineeComponent, { size: 'xl' });
    modalRef.componentInstance.dL = new UTILS().deepCopy(dL);

    let response: DettaglioLinee | undefined = await modalRef.result.then(result => { return result; }).catch(err => { return null });
    if (response) {
      let indexObj = this.fakeLinee.indexOf(dL);
      let obj: DettaglioLineeTemporaneo = new UTILS().deepCopy(response);
      // console.log(obj);
      obj.Quantita = new UTILS().parseFloat(obj.Quantita);
      obj.AliquotaIVA = new UTILS().parseFloat(obj.AliquotaIVA);
      obj.PrezzoUnitario = new UTILS().parseFloat(obj.PrezzoUnitario);
      this.fakeLinee[indexObj] = obj;
      this.getTotImporto(this.fakeLinee[indexObj]);
    }
  }

  public addRiepilogo() {
    this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.push({ AliquotaIVA: '', Arrotondamento: '', EsigibilitaIVA: '', ImponibileImporto: '', Imposta: '', Natura: '', RiferimentoNormativo: '', SpeseAccessorie: '' });
  }

  public deleteRiepilogo(index: number) {
    this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.splice(index, 1);
    this.refreshRiepilogo.emit();
  }

  public notifyChange() {
    this.modelChange.emit(this.model);
  }

  public controllaDecimali(valore: any, decimali: number = 2) {

    var a = valore.split(".");
    var result = "";
    if (a.length == 1) {
      result = Number(valore).toFixed(decimali);
    } else {
      if (a[1].length < 2) {
        result = Number(valore).toFixed(decimali);
      } else {
        result = valore;
      }
    }

    
    return result;
  }

  getTotImporto(dL: DettaglioLinee | DettaglioLineeTemporaneo) {
    let prezzoUnitario: number = +dL.PrezzoUnitario;
    dL.ScontoMaggiorazione.forEach(i => {
      if (i.Importo != '' || i.Percentuale != '') {
        switch (i.Tipo) {
          case "SC":
            if (i.Importo == '' || +i.Importo == 0) {
              // Pecerntuale sconto
              prezzoUnitario = prezzoUnitario - ((prezzoUnitario / 100) * parseFloat("" + i.Percentuale));
            } else {
              // Importo sconto
              prezzoUnitario = prezzoUnitario - parseFloat(i.Importo);
            }
            break;
          case "MG":
            if (i.Importo == '' || +i.Importo == 0) {
              // Pecerntuale sconto
              prezzoUnitario = prezzoUnitario + ((prezzoUnitario / 100) * parseFloat("" + i.Percentuale));
            } else {
              // Importo sconto
              prezzoUnitario = prezzoUnitario + parseFloat(i.Importo);
            }
            break;
        }
      }
    });
    //dL.PrezzoTotale = Math.round(parseFloat("" + (+dL.Quantita * prezzoUnitario).toFixed(2)) * 100) / 100
    //dL.PrezzoTotale = Math.round(parseFloat("" + (+dL.Quantita * prezzoUnitario)) * 100) / 100
    dL.PrezzoTotale = parseFloat(this.toFixedCustom(+dL.Quantita * prezzoUnitario, 5));
    dL.PrezzoTotale.toFixed(8);

  }

  public toFixedCustom(value: any, precision: any) {
    var power = Math.pow(10, precision || 1);
    return String(Math.round(value * power) / power);
  }


  public async salvaArticolo(index: number) {
    let check = true;
    let response: GenericResponse;
    //devono esserci almeno descrizione e prezzo unitario.
    let descrizione = this.fakeLinee[index].Descrizione.trim();
    if (descrizione.length < 2) {
      this.toastService.openToastWithConfig(true, 5000, "La descrizione deve essere di almeno tre caratteri", "warning");
      return;
    }
    let prezzoUnitario = this.fakeLinee[index].PrezzoUnitario;
    let unitaDiMisura = this.fakeLinee[index].UnitaMisura;
    let aliquotaIva = this.fakeLinee[index].AliquotaIVA;
    let naturaEsenzione = this.fakeLinee[index].Natura;

    if ((descrizione == "") || (prezzoUnitario == "")) {
      this.toastService.openToastWithConfig(true, 5000, "Inserisci descrizione e prezzo unitario", "warning");
      return;
    }
    let articolo: Articolo = {
      descrizione: descrizione,
      prezzounitario: Number(prezzoUnitario),
      aliquotaiva: Number(aliquotaIva),
      natura: naturaEsenzione,
      unitadimisura: unitaDiMisura,
      user_id: this.userInfo!.user_id,
      id: ''
    };

    response = await this.confService.saveNewItem(this.userInfo!.user_id, articolo);
    if (response.success) {
      this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate, "toast.save.success"), "success");
    } else {
      this.toastService.openToast(response.msg, "warning");
    }
  }

  public checkRitenuta(event: any, index: number) {
    this.fakeLinee[index].Ritenuta = event.target.checked ? 'SI' : '';
    // devo impostare il valore SI o meno anche nel model della fattura
    this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].Ritenuta = this.fakeLinee[index].Ritenuta;
    //this.aggiornaFakeLinee.emit();
    this.refreshRiepilogo.emit();
  }


  public async checkCassaRiga(event: any, index: number) {
    var response = await this.confermaRicalcoloCassa();
    if (response) {
      this.fakeLinee[index].AppCassa = event.target.checked ? '' : 'SI';
      this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[index].AppCassa = this.fakeLinee[index].AppCassa;
      this.ricalcolaCassePrevidenziali();
      this.refreshRiepilogo.emit();
    }
  }

  async confermaRicalcoloCassa() {
    let modalRef = this.modalService.open(ConfirmModalComponent, { size: 'md' });
    modalRef.componentInstance.title = "Modifica dati Cassa";
    modalRef.componentInstance.description = "Procedendo verranno ricalcolati gli imponibili della cassa previdenziale.Procedere?";
    let response: boolean | undefined = await modalRef.result.then(result => { return result; }).catch(err => { return null });
    return response ? response : false;
  }

  public async changeEsigibilitaIva(event: any, index: number) {
    if (this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length > 0) {
      if (event.key == 'S') {
        var trovato = false;
        for (var i = 0; i < this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
          if (this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA != "S") {
            trovato = true;
          }
        }

        if (trovato) {
          var response = await this.confermaCambioEsigibilitaIva();
          if (response) {
            for (var i = 0; i < this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
              this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA = "S";
            }
          }
          else {
            this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[index].EsigibilitaIVA = "";
          }
        }
      }
      if (event.key != 'S' && this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[index].EsigibilitaIVA == "S") {
        var response = await this.confermaCambioEsigibilitaIva();
        if (response) {
          for (var i = 0; i < this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++)
            this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA = event.key;
        } else {
          for (var i = 0; i < this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++)
            this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA = 'S';
        }
      }
    }
    this.notifyChange();
    this.refreshRiepilogo.emit();
  }

  async confermaCambioEsigibilitaIva() {
    let modalRef = this.modalService.open(ConfirmModalComponent, { size: 'md' });
    modalRef.componentInstance.title = "Modifica Esibilità Iva";
    modalRef.componentInstance.description = "Procedendo verrà cambiata l'Esigibilità Iva di tutte le linee di Riepilogo.Procedere?";
    let response: boolean | undefined = await modalRef.result.then(result => { return result; }).catch(err => { return null });
    return response ? response : false;
  }


  public ricalcolaCassePrevidenziali() {
    if (this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length == 0)
      return;

    let totale = 0;
    let righe = this.model?.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;

    righe?.forEach(function (riga) {
      if (riga.AppCassa != undefined && riga.AppCassa == "SI" && riga.Natura != "N1")
        totale += parseFloat("" + riga.PrezzoTotale);
    });

    this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale!.forEach(function (cassa) {
      cassa.ImponibileCassa = Number(totale).toFixed(2);
      //let tot = parseFloat((cassa.ImponibileCassa as string) != '' ? (cassa.ImponibileCassa as string) : "0") * parseFloat("" + cassa.AlCassa) / 100;
      let tot = totale * cassa.AlCassa;
      cassa.ImportoContributoCassa = Number(parseFloat((totale * (cassa.AlCassa / 100)).toFixed(2)));

    });
  }


  async avvisoLinea() {
    var that = this;
    setTimeout(function () {
      if (that.fakeLinee?.filter(dR => dR.validato == false).length > 0)
        that.toastService.openToast("Ricordati di salvare la linea", "warning");
    }, 4000);
  }


}
